const TheContainer = () => import('@/containers/TheContainer')
const Requests = () => import('./pages/Requests.vue')

const requestRoutes = [
  {
    path: 'requests',
    component: TheContainer,
    children: [
      {
        path: '/',
        name: 'request',
        component: Requests,
        meta: { requiresAuth: true },
      },
    ],
  },
]

export default requestRoutes
